// extracted by css-extract-rspack-plugin
export default {"commentLink":"IssueCommentLink-module__commentLink__RE8kZ"};